<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span><i>Contents</i></span></p>
<p class="toc-entry"><span><a href="#/xhtml/chapter01">1933</a></span></p>
<p class="toc-entry"><span><a href="#/xhtml/chapter02">T<span class="smallcaps">HE</span> C<span class="smallcaps">HOSEN</span> H<span class="smallcaps">USBAND</span></a></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter03" title="Link target outside of Sample">F<span class="smallcaps">ROM</span> C<span class="smallcaps">LOUD TO</span> C<span class="smallcaps">LOUD</span></span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter04" title="Link target outside of Sample">F<span class="smallcaps">LORIDA</span></span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter05" title="Link target outside of Sample">D<span class="smallcaps">ÉDÉ</span></span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter06" title="Link target outside of Sample">K<span class="smallcaps">INGDOM</span> C<span class="smallcaps">OME</span></span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter07" title="Link target outside of Sample">A<span class="smallcaps">CROSS THE</span> B<span class="smallcaps">RIDGE</span></span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter08" title="Link target outside of Sample">F<span class="smallcaps">ORAIN</span></span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter09" title="Link target outside of Sample">A S<span class="smallcaps">TATE OF</span> A<span class="smallcaps">FFAIRS</span></span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter10" title="Link target outside of Sample">M<span class="smallcaps">LLE</span>. D<span class="smallcaps">IAS DE</span> C<span class="smallcaps">ORTA</span></span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter11" title="Link target outside of Sample">T<span class="smallcaps">HE</span> F<span class="smallcaps">ENTON</span> C<span class="smallcaps">HILD</span></span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/endmatter01" title="Link target outside of Sample">About the Author</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?709a60c2